/* eslint-disable */
import React, { useMemo } from 'react';
import { useParams } from 'react-router-dom';
import { useUpdateComponentState } from '../../../hooks';
import Quiz from '../../components/Quiz';
import MisconceptionCards from '../../components/MisconceptionCards';
import quizBg from '../../../../../../assets/student-training/ctis/quiz-bg.png';
import ExpandableListIllustration from '../../components/ExpandableListIllustration';
import NumberedStepsCarousel from '../../components/NumberedStepsCarousel';
import {
  MC_Section3_ICONS,
  ELI_Section3_ICONS,
  NSC_Section3_ICONS,
} from './iconMap';
import stepIllustration from '../../../../../../assets/student-training/ctis/img3.png';
interface ISection1Props {
  settings: any;
}

const NSC_ITEMS = [
  { text: '先了解 AI 工具的運作方式、資料處理政策及使用條款。' },
  { text: '避免輸入敏感資料、帳戶資料或不應外流的專題內容。' },
  { text: '對 AI 輸出進行審查、測試及除錯，確保內容符合專案需求。' },
  { text: '定期檢視已使用的 AI 工具與連接權限，及時移除不再需要的項目。' },
  { text: '保持獨立思考，將 AI 視為輔助而非完全取代個人判斷。' },
];

const Section2: React.FunctionComponent<ISection1Props> = ({ settings }) => {
  const ID = '4';
  const param = useParams();
  const p_course = param.course || '';
  const p_topic = param['*'] || 'welcome';
  const updateComponentState = useUpdateComponentState();
  const paragraphsSettings = useMemo(
    () => settings?.paragraphs[3],
    [settings?.paragraphs]
  );
  const quiz = paragraphsSettings?.quiz;
  const handleMisconceptionCardsComplete = React.useCallback(() => {
    updateComponentState(
      p_course,
      p_topic,
      ID,
      'student-training-ctis-section3-1'
    );
  }, [updateComponentState, p_course, p_topic, ID]);

  const handleEliComplete = React.useCallback(() => {
    updateComponentState(
      p_course,
      p_topic,
      ID,
      'student-training-ctis-section3-2'
    );
  }, [updateComponentState, p_course, p_topic, ID]);

  return (
    <div className="topic-section-3">
      <MisconceptionCards
        title={paragraphsSettings?.title}
        subTitle={paragraphsSettings?.misconceptionCardsTitle}
        items={paragraphsSettings?.misconceptionCardsList}
        tips={paragraphsSettings?.misconceptionCardsTips}
        icons={MC_Section3_ICONS}
        id="student-training-ctis-section3-1"
        onComplete={handleMisconceptionCardsComplete}
      />
      <div style={{ margin: '8rem 0' }}>
        <ExpandableListIllustration
          mainTitle=""
          subTitle={paragraphsSettings?.eliTitle}
          description={paragraphsSettings?.eliDesc}
          illustration={<img src={stepIllustration} alt="" />}
          items={paragraphsSettings?.eliItems}
          id="student-training-ctis-section3-2"
          onComplete={handleEliComplete}
        />
      </div>
      <div style={{ margin: '8rem 0' }}>
        <NumberedStepsCarousel
          type="simple"
          mainTitle={paragraphsSettings?.nscTitle}
          description={paragraphsSettings?.nscDesc}
          items={paragraphsSettings?.nscItems}
        />
      </div>
      <div></div>
      <div id="student-training-ctis-section3-question" className="topic-quiz">
        <Quiz
          title={paragraphsSettings?.questionTitle}
          description={quiz?.description}
          question={quiz?.question}
          options={quiz?.options}
          quizImg={quizBg}
          onCompleted={() => {
            updateComponentState(
              p_course,
              p_topic,
              ID,
              'student-training-ctis-section3-question'
            );
          }}
        />
      </div>
    </div>
  );
};

export default Section2;
